const MobileRecognitionVisibilityView = () => {
  return 'VisibilityView'
}

export default MobileRecognitionVisibilityView
